import { render, staticRenderFns } from "./CollectionProductsGridItem.vue?vue&type=template&id=c0e7c3ec&"
import script from "./CollectionProductsGridItem.vue?vue&type=script&lang=js&"
export * from "./CollectionProductsGridItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectionProductsGridItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports